import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { isEmpty } from 'validate.js';

import { isLessThanBreakpoint } from 'dpl/util/grid';
import { FILTER_COLOR } from 'dpl/constants/query_params';
import {
  ANALYTICS_VIEWS,
  ANALYTICS_VIEW_FEATURES,
  ANALYTICS_VIEW_FEATURE_LOCATIONS
} from 'dpl/constants/analytics';

import FilterPill from './FilterPill';
import ExposedFilterBottomModal from './ExposedFilterBottomModal';
import ExposedFilterDropdown from './ExposedFilterDropdown';
import ColorFilter from './ColorFilter';

const IS_LT_MD = isLessThanBreakpoint('md');

const FILTER_TITLE = 'Filter by color';

export default function ColorFilterButton({ resultsType, totalItemCount }) {
  const { server, queryParams } = useSelector(state => state);
  const { breedColors } = server;
  const isSelected = Boolean(queryParams[FILTER_COLOR]);
  const [isColorFilterOpen, setIsColorFilterOpen] = useState(false);

  const analytics = {
    button_cta: 'color',
    view: ANALYTICS_VIEWS.PUPPY_SEARCH_RESULTS,
    view_feature: ANALYTICS_VIEW_FEATURES.COLOR_FILTER_BUTTON,
    view_feature_location: ANALYTICS_VIEW_FEATURE_LOCATIONS.SEARCH_HEADER
  };

  const FilterButton = (
    <FilterPill
      onClick={() => setIsColorFilterOpen(true)}
      label="Color"
      displayDropdownArrow
      isSelected={isSelected}
      analytics={analytics}
      isOpen={isColorFilterOpen}
    />
  );

  if (isEmpty(breedColors)) {
    return null;
  }

  if (IS_LT_MD) {
    return (
      <>
        {FilterButton}
        <ExposedFilterBottomModal
          isFilterMenuOpen={isColorFilterOpen}
          setIsFilterMenuOpen={setIsColorFilterOpen}
          resultsType={resultsType}
          totalItemCount={totalItemCount}
          title={FILTER_TITLE}
          actionsClassName="bt b--default pt3"
        >
          <ColorFilter filterOptions={breedColors} isColorFilterButton />
        </ExposedFilterBottomModal>
      </>
    );
  }

  return (
    <ExposedFilterDropdown
      isOpen={isColorFilterOpen}
      setIsOpen={setIsColorFilterOpen}
      toggleButton={FilterButton}
      title={FILTER_TITLE}
      setIsMenuOpen={() => setIsColorFilterOpen(false)}
      totalItemCount={totalItemCount}
      resultsType={resultsType}
      actionsClassName="justify-end bt b--default nh5 ph5 pt3"
    >
      <ColorFilter filterOptions={breedColors} isColorFilterButton />
    </ExposedFilterDropdown>
  );
}
ColorFilterButton.propTypes = {
  resultsType: PropTypes.string.isRequired,
  totalItemCount: PropTypes.number.isRequired
};
